module.exports = __webpack_public_path__ + "img/card03.af1f1c1c.png";